import { fromEvent } from 'rxjs'
import { queryAllWithin } from 'lambda-dom'

import { HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'
import { getConsentLevel, setConsentLevel } from './storage.lib'

// ------------------------------------------------------------------------------
//      Navigation theme handling
// ------------------------------------------------------------------------------
{
    const heroContainer = document.getElementById('cookie-settings-hero')!

    const observer = new IntersectionObserver(([element]) => {
        if (element.intersectionRatio >= 0.85) {
            setHeaderDisplay('none')
            setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
        } else {
            setHeaderDisplay('brand-logo')
            setHeaderTheme(HeaderTheme.WHITE)
        }
    }, { threshold: [1, 0.85, 0.1, 0] })

    observer.observe(heroContainer)
}

{
    const onToggle = (toggle: HTMLElement) => {
        const consentLevel = parseInt(toggle.dataset.consentLevel ?? '0', 10)
        setConsentLevel(consentLevel)
        if (! toggle?.classList.contains('right')) {
            toggles.forEach((tgl) => tgl.classList.remove('right'))
            toggle?.classList.add('right')
        }
    }

    const togglesContainer = document.getElementById('toggles')!
    const toggles = queryAllWithin(togglesContainer)<HTMLElement>('.toggle')
    const labels = queryAllWithin(togglesContainer)('.cookie-settings--label')
    const consentLevel = getConsentLevel()

    const defaultToggle = consentLevel
        ? toggles.find((toggle) => toggle.dataset.consentLevel === consentLevel.toString()) ?? toggles[0]
        : toggles[0]

    onToggle(defaultToggle)

    fromEvent(toggles, 'click').subscribe((event) => {
        const toggle = event.currentTarget as HTMLElement
        onToggle(toggle)
    })

    fromEvent(labels, 'click').subscribe((event) => {
        const label = event.currentTarget as HTMLElement
        const toggle = label.previousElementSibling as HTMLElement
        if (toggle) {
            onToggle(toggle)
        }
    })
}

{
    const saveButton = document.querySelector('.cookie-settings--button')

    if (saveButton) {
        saveButton.addEventListener('click', (event) => {
            event.preventDefault()

            window.location.href = document.referrer
        })
    }
}
